"use client";

import React from "react";
import { NoItems } from "@/app/(components)/Basic/NoItems";
import { User } from "@/api/users/types";
import useInfiniteCollectionsForArtist from "../hooks/useInfiniteCollectionsForArtist";
import CollectionSlider from "../CollectionSlider";
import { CollectionItem } from "../CollectionItem";
import { Colors } from "@/shared/constants";
import { ShowMoreButton } from "@/app/(components)/Basic/ShowMoreButton";

export interface Props {
  artist: User;
}
const colors = [Colors.Red, Colors.Green, Colors.Yellow];

const CollectionList = ({ artist }: Props) => {
  const { collections, hasNextPage, fetchNextPage } =
    useInfiniteCollectionsForArtist({
      artist,
    });

  if (!collections?.length) {
    return <NoItems message="No items to display." />;
  }
  return (
    <div className="flex flex-col items-center pl-5 lg:pl-0">
      {collections.map((collection, index) => {
        if (collection.nftCount == 0) {
          return (
            <CollectionItem
              className="px-5"
              title={collection.name}
              artist={collection.artist}
              swap={index % 2 === 0}
              description={collection.description}
              href={`/collection/${collection.slug}`}
              imageSrc={collection.imageUrl}
              imagePlaceholder={collection.imagePlaceholder}
              titleColor={colors[index % 3]}
              key={collection.address}
            />
          );
        }

        return (
          <CollectionSlider
            key={collection.address}
            collection={collection}
            className="lg:w-screen"
          />
        );
      })}
      {hasNextPage && (
        <ShowMoreButton fetchNextPage={fetchNextPage} className="mt-0" />
      )}
    </div>
  );
};

export default CollectionList;
